import type { Infer } from 'superstruct';
import {
	array,
	assign,
	nullable,
	object,
	omit,
	optional,
	partial,
	pick,
	string,
	union,
} from 'superstruct';

import { ViewGoogleAdsAdTemplateDto } from '@adflow/shared/data-google-ads';
import { ViewMediaDto } from '@adflow/shared/data-media';

import { historyArrayItem } from '../history-array-item';

export const HistoryDemandGenCarouselCardDto = partial(
	object({
		images: optional(
			array(
				historyArrayItem(
					pick(ViewMediaDto, ['id', 'name', 'url', 'thumbnailUrl'])
				)
			)
		),
		headline: optional(string()),
		finalUrl: optional(string()),
		cta: optional(string()),
	})
);

export type HistoryDemandGenCarouselCardDto = Infer<
	typeof HistoryDemandGenCarouselCardDto
>;

export const HistoryGoogleAdsAdDto = assign(
	partial(omit(ViewGoogleAdsAdTemplateDto, ['updatedAt'])),
	partial(
		object({
			images: array(
				historyArrayItem(
					pick(ViewMediaDto, ['id', 'name', 'url', 'thumbnailUrl'])
				)
			),
			adObject: optional(
				nullable(
					partial(
						object({
							headline: array(historyArrayItem(string())),
							longHeadline: union([
								array(historyArrayItem(string())),
								string(),
							]),
							description: array(historyArrayItem(string())),
							displayUrlPath: array(historyArrayItem(string())),
							videos: array(historyArrayItem(string())),
							siteLinks: optional(nullable(array(historyArrayItem(string())))),
							finalUrl: string(),
							cta: optional(string()),
							cards: array(historyArrayItem(HistoryDemandGenCarouselCardDto)),
						})
					)
				)
			),
			// Only used to distinguish groups on UI
			adName: optional(string()),
		})
	)
);

export type HistoryGoogleAdsAdDto = Infer<typeof HistoryGoogleAdsAdDto>;
